const focusHandler = (): void => {
  window.removeEventListener('focus', focusHandler);
  location.reload();
};

export const reloadPageWhenWindowFocused = (): void => {
  window.addEventListener('focus', focusHandler);
};
